import { isTextSelection, useEditorState } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';

import { Flex } from '@backstage/ui';

import { BlockTypeSelect } from './BlockTypeSelect';
import { CommentButton } from './Comment';
import { useCurrentEditor } from './Context';
import { ToolbarCard } from './FloatingCard';
import { InlineFormatButtons } from './InlineFormatButtons';

const ToolbarContent = () => {
  const { editor } = useCurrentEditor();

  const hideBlockTypeSelect = useEditorState({
    editor,
    selector: ctx => {
      if (!ctx.editor) return false;
      if (ctx.editor.isActive('tag')) return true;

      const { $from } = ctx.editor.state.selection;
      for (let depth = $from.depth; depth > 0; depth--) {
        if ($from.node(depth).type.name === 'highlightBlock') return true;
      }
      return false;
    },
  });

  if (!editor) return null;

  return (
    <ToolbarCard p="0.5">
      <Flex gap="0.5">
        {!hideBlockTypeSelect && <BlockTypeSelect />}
        <InlineFormatButtons />
        <CommentButton />
      </Flex>
    </ToolbarCard>
  );
};

export const SelectionToolbar = () => {
  const { editor } = useCurrentEditor();

  return (
    <BubbleMenu
      editor={editor ?? undefined}
      options={{ offset: 6, placement: 'top' }}
      style={{ zIndex: 99999 }}
      shouldShow={({ view, state, from, to }) => {
        // Reworked from the default, because we only want the selection
        // menu for text selections where a mark change will be visible.
        // https://github.com/ueberdosis/tiptap/blob/063ced27ca55f331960b01ee6aea5623eee0ba49/packages/extension-bubble-menu/src/bubble-menu-plugin.ts#L43
        if (!view.hasFocus()) return false;
        const { doc, selection } = state;
        const isText = isTextSelection(selection);
        if (!isText) return false;
        const isEmpty =
          selection.empty || (isText && doc.textBetween(from, to).length === 0);
        if (isEmpty) return false;
        return true;
      }}
    >
      <ToolbarContent />
    </BubbleMenu>
  );
};
